const datasetBrowser = {
  loading: "Loading datasets...",
  failedToLoad: "Failed to load datasets",
  downloadFailed: "Download failed",
  organizationWide: "Organization-wide",
  title: "Browse Datasets",
  subtitle:
    "Every dataset you can see across your projects, whether or not you have access yet",
  searchPlaceholder: "Search by name, description, or uploader...",
  filters: {
    all: "All ({{count}})",
    available: "Available for download ({{count}})",
    request: "Needs a request ({{count}})",
  },
  sort: {
    date: "Recently added",
    name: "Name (A-Z)",
  },
  noDatasets: "No datasets available to your projects",
  noDatasetsMatchSearch: "No datasets match your search",
  rowsCount: "{{formatted}} rows",
  rowsCountUnknown: "N/A rows",
  columnsCount: "{{count}} columns",
  detailEmpty: {
    search: "No datasets match your search.",
    available: "No datasets are available for direct download.",
    request:
      "No datasets need a request — you already have access to everything you can see.",
    none: "No datasets to show.",
  },
  downloading: "Downloading…",
  downloadWorkbook: "Download workbook",
  downloadCsv: "Download as CSV",
  downloadCsvTitle: "Flattened first sheet, supports column selection",
  requestAccess: "Request access",
};

export default datasetBrowser;
